import { Grid } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useState, useEffect, useRef } from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { Close } from '@HomaHealth/ui-component-library';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import { commonDropDownProps } from '../../atoms/ReportsCohortItem';
import NewEditDuration, { InitialDates } from '../../molecules/NewEditDuration';
import AddCohortInfo from '../../molecules/AddCohortInfo';
import { useStores } from '../../../stores';
import { Button } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { toJS } from 'mobx';
import CohortDetailsModal from '../CohortDetailsModal';
import { getMonthInResponseFormat } from '../../../core-utils/helper-utils/helper';
import {
  UserAccessConstants,
  checkUserAccess,
} from '../../../core-utils/helper-utils/userAccess';
import FeatureAccessModal from '../FeatureAccessModal';
import { ICohortDetails } from '../CreateNewModalCoreComponent';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';
import AutocompleteWithCheckBoxes from '../../atoms/Autocomplete';
import { useNavigate } from 'react-router-dom';
import { CUSTOM_QUERY_BUILDER, HOME_SCREEN } from '../../../core-utils/routes';
import { TextField } from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import {
  getAllEmployerGroups,
  getPlanPeriodDates,
} from '../../../core-utils/helper-utils/reportsWorkFlowHelper';
import { DATE_FORMAT } from '../../../core-utils/messages/CommonConstants';
import moment from 'moment';
import axios from 'axios';
import properties from '../../../core-utils/properties';

export interface CreateNewQueryModalProps {
  setOpen: any;
  status: 'VIEW' | 'CREATE' | 'UPDATE';
  setLoading?: React.Dispatch<React.SetStateAction<boolean>>;
  hideOnClose?: boolean;
}

const EditDurationStyles = {
  mainComponent: {
    backgroundColor: 'inherit',
    boxShadow: 'none',
    border: 'none',
    width: 'auto ',
    height: 'auto',
  },
  dateContainerStyles: {
    marginLeft: '0px',
    marginTop: '20px',
  },
  infoStyles: {
    display: 'none',
  },
};

const CreateNewQueryModal: React.FC<CreateNewQueryModalProps> = ({
  setOpen,
  status,
  setLoading,
  hideOnClose,
}) => {
  // constants
  const constants = componentConstants.ORGANISMS.CREATE_NEW_QUERY_MODAL;

  // hooks
  const navigate = useNavigate();
  const customDashboardStore = useStores().customDashboardStore;
  const loginPageStore = useStores().loginPageStore;
  const employerGroupStore = useStores().employerGroupStore;
  const customQueriesStore = useStores().customQueriesStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;

  // states
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [
    isCohortDetailsModalOpen,
    setIsCohortDetailsModalOpen,
  ] = useState<boolean>(false);
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);
  const [cohortDetailsList, setCohortDetailsList] = useState<ICohortDetails[]>(
    toJS(customQueriesStore.cohortDetailsList).length > 0
      ? toJS(customQueriesStore.cohortDetailsList)
      : [
          {
            id: 1,
            category: '',
            condition: '',
            property: '',
            dropdownSelectionTypeIndex: 0,
            propertiesPageNumber: 0,
            totalPagesForProperties: 0,
          },
        ],
  );
  const [isEditCohorts, setIsEditCohorts] = useState<boolean>(
    toJS(customQueriesStore.cohortDetailsList).length !== 0,
  );

  const [cohortsPopUpLoading, setCohortsPopUpLoading] = useState<boolean>(true);

  const [selectedEmployerGroups, setSelectedEmployerGroups] = useState<
    {
      id: string;
      name: string;
      eg_nid: string;
      lastUpdated: string;
      start_month: string;
      start_year: number;
      end_month: string;
      end_year: number;
      plan_start_month: string;
      plan_end_month: string;
      recent_plan_year: number;
    }[]
  >(toJS(customQueriesStore.employerGroups));

  const [planPeriod, setPlanPeriod] = useState<InitialDates>(
    toJS(customQueriesStore.planPeriod),
  );
  const [resetDates, setResetDates] = useState<boolean>(false);
  const [totalMemberCount, setTotalMemberCount] = useState<number>(0);

  const [type, setType] = useState<string>(
    toJS(customQueriesStore.type) || 'Members',
  );
  const [features, setFeatures] = useState<string[]>(
    toJS(customQueriesStore.features) || [],
  );
  const [queryName, setQueryName] = useState<string>(
    toJS(customQueriesStore.name) || '',
  );

  const typeRef = useRef(toJS(customQueriesStore.type));

  // styles
  const useStyles = makeStyles()({
    root: {
      width: '720px',
      maxHeight: '720px',
      backgroundColor: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 32px 20px 32px',
      position: 'absolute',
      top: '60%',
      left: '50%',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    mainFieldsContainer: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      marginTop: '16px',
      boxSizing: 'border-box',
      width: '656px',
      background: '#FBFBFE',
      border: `1px solid ${patientAccessTheme.palette.grey[100]}`,
      borderRadius: '8px',
      padding: '20px 18px',
      marginBottom: '24px',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border:
        '1px solid ' + !(Boolean(type) && Boolean(features.length))
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });
  const { classes } = useStyles();

  // functions
  const handleClose = () => setOpen(false);

  const getText = (
    constants: {
      VIEW: string;
      SAVE: string;
      UPDATE: string;
    },
    status: 'VIEW' | 'CREATE' | 'UPDATE',
  ) => {
    switch (status) {
      case 'VIEW':
        return constants.VIEW;
      case 'CREATE':
        return constants.SAVE;
      case 'UPDATE':
        return constants.UPDATE;
    }
  };

  const handleSave = async (requestBody: any) => {
    if (setLoading) {
      setLoading(true);
    }
    await axios.post(
      properties.userManagementBaseUrl + properties.customQueries,
      requestBody,
    );
    setOpen(false);
    if (setLoading) {
      setLoading(false);
    }
  };

  const handleUpdate = async (requestBody: any) => {
    if (setLoading) {
      setLoading(true);
    }
    await axios.patch(
      properties.userManagementBaseUrl + properties.customQueries,
      requestBody,
    );
    setOpen(false);
    if (setLoading) {
      setLoading(false);
    }
  };

  const getTotalMemberCount = async () => {
    const responseBody = {
      eg_nid: selectedEmployerGroups.map((item) => item.eg_nid),
      startYear: moment(startDate, DATE_FORMAT).year(),
      startDate: startDate,
      endDate: endDate,
      member_unique_id_list: [],
      feature_list: ['Member ID'],
    };

    await axios
      .post(
        properties.aiqBaseUrl +
          properties.customQueryBuild +
          properties.customQueryMemberDetails,
        responseBody,
      )
      .then((response) => {
        const responseData = response?.data?.response;
        setTotalMemberCount(responseData.totalCount);
      });
    setCohortsPopUpLoading(false);
  };

  const handleView = () => {
    customQueriesStore.setCustomQueriesData(
      '',
      '',
      type,
      features,
      cohortDetailsStore.memberUniqueIdList,
      cohortDetailsStore.claimIdList,
      selectedEmployerGroups,
      {
        start_month: '',
        end_month: '',
        plan_start_month: '',
        start_year: 0,
        end_year: 0,
        plan_end_month: '',
        recent_plan_year: 0,
      },
      {
        startDate,
        endDate,
      },
      '',
      cohortDetailsList,
      '',
    );
    if (location?.pathname.includes(HOME_SCREEN)) {
      customQueriesStore.setIsIndividualGroup(true);
      navigate(CUSTOM_QUERY_BUILDER, { state: { hideCreateQueryModal: true } });
    }
    setOpen(false);
  };

  const handleSubmit = async () => {
    const momentStartDate = moment(startDate, DATE_FORMAT);
    const momentEndDate = moment(endDate, DATE_FORMAT);
    const requestBody = {
      id: customQueriesStore.id,
      name: queryName,
      employerGroupIds: selectedEmployerGroups.map((item) => item.eg_nid),
      queryType: type,
      features: features,
      cohortDetailsList,
      downloadFrequency: customQueriesStore.downloadfrequency || 'monthly',
      startMonth: getMonthInResponseFormat(
        (momentStartDate.month() + 1).toString(),
      ),
      startYear: momentStartDate.year(),
      endMonth: getMonthInResponseFormat(
        (momentEndDate.month() + 1).toString(),
      ),
      endYear: momentEndDate.year(),
      deleted: false,
      createdBy: customQueriesStore.createdBy || loginPageStore.userId,
      memberIds: cohortDetailsStore.memberUniqueIdList,
      claimIds: cohortDetailsStore.claimIdList,
    };
    switch (status) {
      case 'VIEW':
        handleView();
        return;
      case 'CREATE':
        await handleSave(requestBody);
        return;
      case 'UPDATE':
        await handleUpdate(requestBody);
        return;
    }
  };

  // useEffects
  useEffect(() => {
    if (isCohortDetailsModalOpen) {
      if (
        startDate &&
        endDate &&
        startDate !== 'Invalid date' &&
        endDate !== 'Invalid date'
      ) {
        getTotalMemberCount();
      }
    }
    setPlanPeriod(getPlanPeriodDates(selectedEmployerGroups));
  }, [startDate, endDate, selectedEmployerGroups, isCohortDetailsModalOpen]);

  useEffect(() => {
    customDashboardStore.setTempSelectedCohorts(cohortDetailsList);
    setIsEditCohorts(toJS(customQueriesStore.cohortDetailsList).length > 0);
  }, [customQueriesStore.cohortDetailsList]);

  useEffect(() => {
    if (typeRef.current !== type) {
      setFeatures([]);
    }
  }, [type]);

  return (
    <>
      <Grid container className={classes.root}>
        <Grid
          container
          sx={{
            justifyContent: 'space-between',
          }}
        >
          <Grid>
            <Typography
              fontSize="18px"
              lineHeight="26px"
              fontType="medium"
              textColor={patientAccessTheme.palette.text.highemphasis}
              margin="0px 0px 4px 0px"
            >
              {getText(constants.TITLE, status)}
            </Typography>
          </Grid>
          {!hideOnClose && (
            <Grid style={{ height: '14px', width: '14px' }}>
              <Close
                height={'14px'}
                width={'14px'}
                fill={patientAccessTheme.palette.status.icon}
                onClick={handleClose}
                cursor={'pointer'}
              />
            </Grid>
          )}
        </Grid>
        <Grid>
          <Typography
            fontSize="14px"
            lineHeight="177%"
            fontType="regular"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            margin="0px 0px 4px 0px"
          >
            {getText(constants.SUBTITLE, status)}
          </Typography>
        </Grid>

        {/* TODO: Need to handle Dropdown options properly */}

        <Grid className={classes.mainFieldsContainer}>
          <Grid
            container
            sx={{
              justifyContent: 'space-between',
            }}
          >
            {status === 'CREATE' || status === 'UPDATE' ? (
              <>
                <Grid>
                  <ReportCreateNewLabelField
                    label={constants.QUERY_NAME}
                    component={
                      <TextField
                        value={queryName}
                        placeholder={constants.QUERY_NAME}
                        height="36px"
                        width="301px"
                        inputPropsStyle={{
                          paddingLeft: '16px',
                        }}
                        onChange={(event: any) =>
                          setQueryName(event.target.value as string)
                        }
                      />
                    }
                    marginBottom="12px"
                  />
                </Grid>
                <Grid>
                  <ReportCreateNewLabelField
                    label={constants.EMPLOYER_GROUPS}
                    component={
                      <AutocompleteWithCheckBoxes
                        options={getAllEmployerGroups(
                          employerGroupStore.allEmployerGroupsData,
                        )}
                        defaultValue={selectedEmployerGroups}
                        handleChange={(event: any, value: any) => {
                          setSelectedEmployerGroups(value);
                          setResetDates((prev) => !prev);
                          setPlanPeriod(getPlanPeriodDates(value));
                        }}
                        placeholder={
                          selectedEmployerGroups?.length === 0
                            ? constants.EMPLOYER_GROUPS_PLACEHOLDER
                            : ''
                        }
                      />
                    }
                    marginBottom="12px"
                  />
                </Grid>
              </>
            ) : (
              <></>
            )}
            <Grid>
              <ReportCreateNewLabelField
                label={constants.TYPE}
                component={
                  <Dropdown
                    label={''}
                    dropDownOptions={Object.keys(
                      toJS(customQueriesStore.typesAndFeatures),
                    )}
                    dropDownValues={Object.keys(
                      toJS(customQueriesStore.typesAndFeatures),
                    )}
                    value={type}
                    setValue={null}
                    handleChange={(e) => {
                      setType(e.target.value as string);
                    }}
                    selectStyles={{
                      ...commonDropDownProps.selectStyles,
                      width: '301px',
                    }}
                  />
                }
                marginBottom="12px"
              />
            </Grid>
            <Grid>
              <ReportCreateNewLabelField
                label={constants.FEATURES}
                component={
                  <AutocompleteWithCheckBoxes
                    options={
                      toJS(customQueriesStore?.typesAndFeatures)[type]?.features
                    }
                    defaultValue={features}
                    handleChange={(e, value) => setFeatures(value)}
                    disabled={!type}
                    placeholder={
                      features?.length === 0
                        ? constants.FEATURES_PLACEHOLDER
                        : ''
                    }
                  />
                }
                marginBottom="12px"
              />
            </Grid>
          </Grid>
          <AddCohortInfo
            isEdit={isEditCohorts}
            onClick={() => setIsCohortDetailsModalOpen(true)}
          />
          <Grid>
            {selectedEmployerGroups.length > 0 ? (
              <NewEditDuration
                initialDates={planPeriod}
                currentDates={
                  toJS(customQueriesStore.currentDates).startDate &&
                  toJS(customQueriesStore.currentDates).endDate
                    ? toJS(customQueriesStore.currentDates)
                    : undefined
                }
                startDateUseState={[startDate, setStartDate]}
                endDateUseState={[endDate, setEndDate]}
                getAllApis={() => {}}
                showOnlyMainComponent={true}
                isYearGrid={false}
                hideTitle={true}
                forCreateNewReports={true}
                mainComponentStyles={EditDurationStyles.mainComponent}
                dateContainerStyles={EditDurationStyles.dateContainerStyles}
                infoStyles={EditDurationStyles.infoStyles}
                resetDates={resetDates}
              />
            ) : (
              <></>
            )}
          </Grid>
        </Grid>

        <Grid
          container
          sx={{
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {!hideOnClose && (
            <Grid style={{ marginRight: '12px' }}>
              <Button
                label={constants.CANCEL}
                variant="outlined"
                className={classes.cancelButton}
                onClick={handleClose}
              />
            </Grid>
          )}

          <Grid>
            <Button
              label={getText(constants.SUBMIT_BUTTON, status)}
              variant="contained"
              className={classes.saveButton}
              disabled={!(Boolean(type) && Boolean(features.length))}
              onClick={handleSubmit}
            />
          </Grid>
        </Grid>
      </Grid>
      {isCohortDetailsModalOpen && (
        <CohortDetailsModal
          open={isCohortDetailsModalOpen}
          title={
            customDashboardStore.isEdit
              ? constants.COHORTS.TITLE2
              : constants.COHORTS.TITLE1
          }
          subTitle={constants.COHORTS.SUB_TITLE}
          startDate={startDate}
          endDate={endDate}
          employerGroup={selectedEmployerGroups.map((item) => item.eg_nid)}
          setOpenCohortDetailsModal={setIsCohortDetailsModalOpen}
          handleClose={() => {
            setIsCohortDetailsModalOpen(false);
            setCohortDetailsList(
              customDashboardStore.isEdit &&
                toJS(customDashboardStore.selectedCohorts) !== null
                ? toJS(customDashboardStore.selectedCohorts)
                : toJS(customDashboardStore.tempSelectedCohorts),
            );
            setCohortsPopUpLoading(true);
          }}
          handleSave={() => {
            customDashboardStore.setTempSelectedCohorts(cohortDetailsList);
            setIsCohortDetailsModalOpen(false);
            setIsEditCohorts(true);
            setCohortsPopUpLoading(true);
          }}
          totalResults={totalMemberCount.toString()}
          isLoading={cohortsPopUpLoading}
        />
      )}
      {openFeatureAccessModal && (
        <FeatureAccessModal
          open={openFeatureAccessModal}
          handleClose={() => {
            setOpenFeatureAccessModal(false);
          }}
          access={checkUserAccess(
            UserAccessConstants.COHORT_DETAILS,
            loginPageStore.userResponse.role.name,
            loginPageStore.userFeatures,
          )}
        ></FeatureAccessModal>
      )}
    </>
  );
};

export default CreateNewQueryModal;
